export default "__VITE_ASSET__NEXbdDcg__"